import styled, { css } from 'styled-components';
import Status from '../types/enum/Status';

type Props = {
  isOpen?: boolean;
  isBehalfActive?: boolean;
} & React.HTMLProps<HTMLDivElement>;

const Sidebar = styled.div<Props>`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${({ theme, isOpen }) =>
    isOpen ? theme.sidebarWidth : `calc(${theme.sidebarWidth} - 180px)`};
  background-color: white;
  box-shadow: ${({ theme }) => theme.shadow(8, Status.default)};
  transition: all ${({ theme }) => theme.transitionTime.default};
  z-index: 1000;
  padding-right: 12px;
  padding-left: 12px;
  padding-top: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: auto;
`;
// <Sidebar isOpen={true}>...</Sidebar>
// ${({ isOpen }) => !isOpen
//     && css`
//       transform: translateX(-100%);
//     `}
export default Sidebar;
